import React from 'react';
import * as Yup from 'yup';
import { Formik } from 'formik';
import PropTypes from 'prop-types';
import Field from '../field';
import ButtonRecipe from '../buttonRecipe';
import Select from '../select';
import { Form, Footer } from './styles';

const ProfileEditionModal = ({ onClose }) => {
  return (
    <Formik
      initialValues={{
        name: '',
        phone: '',
        email: '',
        pharmaceuticalCrf: '',
        pharmaceuticalUfCrf: '',
      }}
      validationSchema={Yup.object({
        name: Yup.string().required('Campo obrigatório'),
        phone: Yup.string().required('Campo obrigatório'),
        email: Yup.string().required('Campo obrigatório'),
        pharmaceuticalCrf: Yup.string().required('Campo obrigatório'),
        pharmaceuticalUfCrf: Yup.string().required('Campo obrigatório'),
      })}
      onSubmit={(values) => {
        return values;
      }}
    >
      {(props) => (
        <Form onSubmit={props.handleSubmit}>
          <div>
            <Field
              error={props.touched.name && props.errors.name}
              id="name"
              name="name"
              placeholder="Digite seu nome"
              label="nome"
              value={props.values.name}
              onChange={props.handleChange}
            />

            <Field
              error={props.touched.email && props.errors.email}
              id="email"
              name="email"
              placeholder="Digite seu e-mail"
              label="e-mail"
              value={props.values.email}
              onChange={props.handleChange}
            />
          </div>

          <div>
            <Field
              error={props.touched.phone && props.errors.phone}
              id="phone"
              name="phone"
              placeholder="Digite seu telefone"
              label="telefone"
              value={props.values.phone}
              onChange={props.handleChange}
            />

            <div>
              <Field
                error={
                  props.touched.pharmaceuticalCrf &&
                  props.errors.pharmaceuticalCrf
                }
                id="pharmaceuticalCrf"
                name="pharmaceuticalCrf"
                placeholder="Digite o número"
                label="Nº CRF Farmacêutico"
                value={props.values.pharmaceuticalCrf}
                onChange={props.handleChange}
              />
              <Select
                error={
                  props.touched.pharmaceuticalUfCrf &&
                  props.errors.pharmaceuticalUfCrf
                }
                id="pharmaceuticalUfCrf"
                name="pharmaceuticalUfCrf"
                placeholder="Selecione"
                label="UF CRF"
                data={[
                  {
                    value: '1',
                    label: 'Jorge',
                  },
                ]}
                value={props.values.pharmaceuticalUfCrf}
                onChange={props.handleChange}
              />
            </div>
          </div>

          <Footer>
            <ButtonRecipe
              type="button"
              width="111px"
              textColor="#2196f3"
              backgroundColor="#F9F9FB"
              borderColor="#2493EB"
              onClick={onClose}
            >
              Cancelar
            </ButtonRecipe>
            <ButtonRecipe
              type="submit"
              width="152px"
              textColor="#fff"
              backgroundColor="#2493EB"
              borderColor="#2493EB"
              marginLeft="20px"
              marginRight="none"
            >
              Salvar
            </ButtonRecipe>
          </Footer>
        </Form>
      )}
    </Formik>
  );
};

ProfileEditionModal.propTypes = {
  onClose: PropTypes.func,
  handleChange: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  touched: PropTypes.func.isRequired,
  errors: PropTypes.func.isRequired,
  values: PropTypes.object.isRequired,
};
ProfileEditionModal.defaultProps = {
  onClose: () => {},
};

export default ProfileEditionModal;
